import Service from "../../../service/api";
import { data } from "jquery";

const CoursesModule = {
    namespaced: true,
    state: {
        popCoursesData: "",
        freeCoursesData: "",
        newCoursesData: "",
        mfuCoursesData: "",
        allCourse: "",
        instructorCourse: [],
        courseDetail: [],
        instructorEnrolledCourse: "",
        courseCodeandInProgressStatus: [],
        courseChapterAndProgress: [],
        courseTopic: [],
        courseTopicUpdated: false,
        getCourseObjectParams: "",
        courseUserProgress: [],
        coursePage: "",
        quiz: [],
        courseQuizPermission: [],
        dataExport: [],
        isChangeComponent: false,
        isCompleteCourse: "",
        exportLoading: false,
        completePostTest: null,
        dataExportChinese2: [],
        mfuREG : null,
        mfuREGSingle : null,
        mfuREGSingleFail : null
    },
    mutations: {
        setNewCourses(state, res) {
            state.newCoursesData = res;
        },
        setFreeCourses(state, res) {
            state.freeCoursesData = res;
        },
        setPopCourses(state, res) {
            state.popCoursesData = res;
        },
        setMFUCourses(state, res) {
            state.mfuCoursesData = res;
        },
        setAllCourses(state, res) {
            state.allCourse = res;
        },
        setInstructorCourse(state, res) {
            state.instructorCourse = res.data;
        },
        setCourseDetail(state, res) {
            state.courseDetail = res;
        },
        setCourseCodeandInProgressStatus(state, res) {
            state.courseCodeandInProgressStatus = res;
        },
        setCourseChapterAndProgress(state, res) {
            state.courseChapterAndProgress = res;
        },
        setCourseTopic(state, res) {
            state.courseTopic = res.data;
        },
        setTopicUpdated(state, res) {
            state.courseTopicUpdated = res;
        },
        setCourseId(state, res) {
            state.getCourseObjectParams = res;
        },
        setCourseProgress(state, res) {
            state.courseUserProgress = res;
        },
        setQuiz(state, res) {
            state.quiz = res;
        },
        setCourseQuizPermission(state, res) {
            state.courseQuizPermission = res;
        },
        setCourseQuizPermissionZero(state) {
            state.courseQuizPermission = []
        },
        setDataExport(state, res) { // export chn1 receive value from api like getter
            state.dataExport = res
            state.exportLoading = false
        },
        checkIsChangeComponent(state, res) {
            state.isChangeComponent = res
        },
        setCompleteCourseStatus(state, res) {
            state.isCompleteCourse = res
        },
        setCoursePage(state, res) {
            state.coursePage = res
        },
        setExportLoading(state, res) {
            state.exportLoading = res
        },
        setCompletePostTestStatus(state, res) {
            state.completePostTest = res
        },
        setDataExportChinese2(state, res) {
            state.dataExportChinese2 = res
        },

        mfuREGEnrollCourse(state, res) {
            state.mfuREG = res
        },

        mfuREGEnrollSingle(state, res) {
            state.mfuREGSingle = res
        },
        mfuREGEnrollSingleFail(state, err) {
            state.mfuREGSingleFail = err
        }
    },
    actions: {

        mfuREGEnroll({ commit }) {
            Service.regEnrollCourse()
                .then((res) => {
                    commit("mfuREGEnrollCourse", res);
                })
                .catch((err) => console.log("Error: mfu enroll course :", err));
        },
        mfuREGEnrollSingle({ commit }, courseId) {
            Service.regEnrollCourseSingle(courseId)
                .then((res) => {
                    commit("mfuREGEnrollCourse", res);
                })
                .catch((err) => {
                    console.log("Error: mfu enroll course :", err)
                    commit("mfuREGEnrollSingleFail", err);
                });
        },

        fetchCourseTopic({ commit }, courseCode) {
            Service.fetchCourseTopic(courseCode)
                .then((res) => {
                    commit("setCourseTopic", res.data);
                })
                .catch((err) => console.log("Error:get course topics :", err));
        },
        fetchCourseQuizPermission({ commit }, body) {
            let bobyHolder = {
                courseId: body,
            };
            Service.fetchCourseQuizPermissionAPI(bobyHolder)
                .then((res) => {
                    commit("setCourseQuizPermission", res.data.checkExam);
                })
                .catch((err) => console.log("Error:get course topics :", err));
        },
        fetchCourses({ commit }) {
            console.log('vuex ---> fetchCourses')
            Service.fetchCourses()
                .then((res) => {
                    let allCourse = res.data.data;
                    // console.log('allCourse:',allCourse);
                    let popularCourses = allCourse.filter((item) => {
                        return item.typeGroup === "Popular";
                    });
                    let newCourses = allCourse.filter((item) => {
                        return item.typeGroup === "News";
                    });
                    let freeCourses = allCourse.filter((item) => {
                        return item.typeGroup === "Free";
                    });
                    let mfuCourses = allCourse.filter((item) => {
                        return item.typeGroup === "MFU";
                    });
                    commit("setAllCourses", allCourse);
                    commit("setPopCourses", popularCourses);
                    commit("setFreeCourses", freeCourses);
                    commit("setNewCourses", newCourses);
                    commit("setMFUCourses", mfuCourses);
                })
                .catch((err) => console.log(err));
        },
        fetchInstructorsCourse({ commit }) {
            let date = new Date();
            let semester = 0;
            if (date.getMonth() <= 4) {
                semester = 2;
            } else if (date.getMonth() >= 5 && date.getMonth() <= 7) {
                semester = 3;
            } else if (date.getMonth() > 7 && date.getMonth() < 11) {
                semester = 1;
            }
            let academicYearTmp = semester == 3 || semester == 2 ? (date.getFullYear() - 1) + 543 : date.getFullYear() + 543;
            let body = {
                academicYear: academicYearTmp,
                semester: semester,
            };
            Service.getIntructorCourseAPI(body)
                .then((res) => {
                    commit("setInstructorCourse", res.data);
                })
                .catch((err) => console.log(err));
        },
        fetchCourseDetail({ commit }, body) {
            Service.getCourseDetailAPI(body)
                .then((res) => {
                    commit("setCourseDetail", res.data.data);
                })
                .catch((err) => console.log("err", err.response.data));
        },
        fetchCoursePage({ commit }, courseCode) {
            Service.fetchCoursePage(courseCode).then((res) => {
                commit("setCoursePage", res.data);
            }).catch((err) => console.log(err));
        },
        fetchCourseChapterAndProgress({ commit }, params) {
            Service.getCourseChapterAndProgress(params)
                .then((res) => {
                    commit("setCourseChapterAndProgress", res.data.data);
                })
                .catch((err) => console.log(err));
        },
        fetchCourseChapterAndProgressHomePage({ commit }, params) {
            Service.getCourseAndProgressHomePage(params)
                .then((res) => {
                    commit("setCourseChapterAndProgress", res.data.data);
                })
                .catch((err) => console.log(err));
        },
        fetchProgressMenu({ commit }, payload) {
            console.log(payload);
            Service.getProgressMenu(payload)
                .then((res) => {
                    commit("setCourseChapterAndProgress", res.data.data);
                })
                .catch((err) => console.log(err));
        },
        fetchProgressChapter({ commit }, params) {
            Service.getProgressChapter(params)
                .then((res) => {
                    commit("setCourseChapterAndProgress", res.data.data);
                })
                .catch((err) => console.log(err));
        },
        updateTopicProgress({ commit }, body) {
            commit("setTopicUpdated", false);

            Service.onUpdateTopicProgress(body)
                .then((res) => {

                    commit("setTopicUpdated", true);
                })
                .catch((err) => console.log(err));
        },
        fetchCourseProgress({ commit }, coursecode) {
            Service.getCourseProgress(coursecode)
                .then((res) => {
                    commit("setCourseProgress", res);
                })
                .catch((err) => console.log("getCourseProgress", err));
        },
        fetchQuiz({ commit }, body) {
            Service.getLockTest(body)
                .then((res) => {
                    commit("setQuiz", res.data.data);
                })
                .catch((err) => console.log(err));
        },

        updateQuizStatus({ commit }, body) {
            Service.updateQuizStatus(body)
                .then((res) => {
                    commit("setQuiz", res.data.data);
                })
                .catch((err) => console.log(err));
        },
        fetchDataExport({ commit }, body) { //chn1 exports score
            console.log('fetchDataExport');
            commit("setExportLoading", true);
            Service.getDataExport(body)
                .then((res) => {
                    commit("setDataExport", res.data);
                })
                .catch((err) => console.log(err));
        },
        pblsDataExport({ commit }, body) { //chn1 exports score
            console.log('PBLSDataExport');
            commit("setExportLoading", true);
            Service.getDataExport(body)
                .then((res) => {
                    commit("setDataExportPBLS", res.data);
                })
                .catch((err) => console.log('err',err));
        },

        updateCompleteCourse({ commit }, body) {
            let data = {
                "courseId": body
            }
            Service.setCompleteCourse(data)
                .then((res) => {
                    commit("setCompleteCourseStatus", res.data);
                })
                .catch((err) => console.log(err));
        },
        fetchCompletePostTestStatus({ commit }, body) {
            Service.getCompletePostTest(body)
                .then((res) => {
                    commit("setCompletePostTestStatus", res.data);
                })
                .catch((err) => console.log(err))
        },
        fetchDataExportChinese2({ commit }, body) {
            commit("setExportLoading", true);
            Service.getDataExportChinese2(body)
                .then((res) => {
                    commit("setDataExportChinese2", res.data.data);
                })
                .catch((err) => console.log(err))
        }

    },
    getters: {
        getNewCourses(state) {
            return state.newCoursesData;
        },
        getPopCourses(state) {
            return state.popCoursesData;
        },
        getMFUCourses(state) {
            return state.mfuCoursesData;
        },
        getFreeCourses(state) {
            return state.freeCoursesData;
        },
        getAllCourses(state) {
            return state.allCourse;
        },
        getInstructorsCourse(state) {
            return state.instructorCourse;
        },
        getCourseDetail(state) {
            return state.courseDetail;
        },
        getEnrolledCourseCard(state) {
            return state.instructorEnrolledCourse;
        },
        getCourseCodeandInProgressStatus(state) {
            return state.courseCodeandInProgressStatus;
        },
        getCourseChapterAndProgress(state) {
            return state.courseChapterAndProgress;
        },
        getCourseTopicID(state) {
            return state.courseTopic;
        },
        getCourseTopicUpdated(state) {
            return state.courseTopicUpdated;
        },
        getCourseObjectParams(state) {
            return state.getCourseObjectParams;
        },
        getCourseUserProgress(state) {
            return state.courseUserProgress;
        },
        getQuiz(state) {
            return state.quiz;
        },
        getCourseQuizPermission(state) {
            return state.courseQuizPermission;
        },
        getDataExport(state) {
            return state.dataExport
        },
        getIsChangeComponent(state) {
            return state.isChangeComponent
        },
        getCompleteCourseStatus(state) {
            return state.isCompleteCourse
        },
        getCoursePage(state) {
            return state.coursePage
        },
        getExportLoading(state) {
            return state.exportLoading
        },
        getCompletePostTestStatus(state) {
            return state.completePostTest
        },
        getDataExportChinese2(state) {
            return state.dataExportChinese2
        },
        mfuREGEnrollSingle(state) {
            return state.mfuREGSingle;
        },
        mfuREGEnrollSingleFail(state) {
            return state.mfuREGSingleFail;
        },
    },
};

export default CoursesModule;